import { FC } from 'react'
import { Box } from '@mui/material'
import { ContentPartType } from '../api'
import { FullContentChip } from './FullContentChip'
import { ContentAccordion } from './ContentAccordion'
import { ContentAccordionSummary } from './ContentAccordionSummary'
import { ContentAccordionDetails } from './ContentAccordionDetails'
import { useMedia } from '@/fractals/hooks'

type ContentPartProps = {
  part: ContentPartType
  color: string | null
}

export const ContentPart: FC<ContentPartProps> = ({ part, color }) => {
  const { partTitle, isBonusPart, subParts } = part
  const { isTablet, isMobile } = useMedia()
  const isSmallScreen = isTablet || isMobile

  return (
    <Box
      sx={{
        '&+&': {
          marginTop: isSmallScreen ? '24px' : '64px'
        }
      }}>
      {isSmallScreen ? (
        <Box
          sx={{
            backgroundColor: color,
            color: '#fff',
            fontSize: isSmallScreen ? '16px' : '20px',
            lineHeight: '120%',
            fontFamily: 'inherit',
            borderRadius: '8px',
            padding: isSmallScreen ? '8px 16px' : '8px 4px'
          }}>
          <span>{partTitle}</span>
        </Box>
      ) : (
        <FullContentChip label={partTitle} color={color} />
      )}

      <Box width='100%' mt={isSmallScreen ? '16px' : '32px'}>
        {subParts.map(({ id, subPartTitle, lines, subPartDescription }) => (
          <ContentAccordion
            key={id}
            isBonusPart={isBonusPart}
            color={color || ''}
            isSmallScreen={isSmallScreen}>
            <ContentAccordionSummary
              hasLines={lines.length > 0}
              isSmallScreen={isSmallScreen}>
              {subPartTitle}
            </ContentAccordionSummary>
            {lines.length > 0 && (
              <ContentAccordionDetails isSmallScreen={isSmallScreen}>
                {subPartDescription ? <p>{subPartDescription}</p> : null}
                <ul>
                  {lines.map(({ text, id: lineId }) => (
                    <li key={lineId}>{text}</li>
                  ))}
                </ul>
              </ContentAccordionDetails>
            )}
          </ContentAccordion>
        ))}
      </Box>
    </Box>
  )
}
